export const isInViewport = (elements, callback, margin) => {
  if (!elements) return;
  const options = {
   root: null,
   rootMargin: margin ? margin : '0px 0px 100px 0px',
   threshold: 0
  }
 
  const innerCallback = (entries, observer) => {
   entries.forEach(entry => {
    if (!entry.isIntersecting) return
    callback()
    observer.unobserve(entry.target)
   });
  }

  const observer = new IntersectionObserver(innerCallback, options);
  observer.observe(elements);
  return observer
 }

 export const isNotInViewport = (element, callback, margin) => {
  if (!element) return;
  // // Special bonus for those using jQuery
  // if (typeof jQuery === "function" && element instanceof jQuery) {
  //   element = element[0];
  // }

  let rect = element.getBoundingClientRect();

  return !(
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
 }